export default "__VITE_ASSET__CQ0Ps0u0__"